import React from 'react';
import { transformationRows, transformationHeading } from '../data/tables';
export function Transformation() {
  return <section aria-labelledby="transformation-heading" className="bg-white" data-id="element-218" data-mp="ilc74n442qte">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-219" data-mp="mluzqjdtw0wn">
        <h2 id="transformation-heading" className="max-w-[36rem] font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-ink md:text-[44px]" data-id="element-220" data-mp="rl7j2u5hqpuh">
          {transformationHeading}
        </h2>

        {/* Desktop table */}
        <table className="mt-12 hidden w-full border-collapse border border-brass/30 text-left md:table" data-id="element-221" data-mp="11hkblopauxnn">
          <thead data-id="element-222" data-mp="16c83lxjiia6z">
            <tr data-id="element-223" data-mp="1abp9gs2up9co">
              <th scope="col" className="w-1/2 border-b border-brass/30 bg-paper px-6 py-4 font-mono text-[10px] uppercase tracking-label text-slate" data-id="element-224" data-mp="1ac8i1i6m2le1">
                Before the system
              </th>
              <th scope="col" className="w-1/2 border-b border-l border-brass/30 bg-paper px-6 py-4 font-mono text-[10px] uppercase tracking-label text-brass" data-id="element-225" data-mp="1ka690dfuuwac">
                With The Daycare Operating System
              </th>
            </tr>
          </thead>
          <tbody data-id="element-226" data-mp="137g5i6ce1aqj">
            {transformationRows.map((row, index) => <tr key={row.before} className={index % 2 === 0 ? 'bg-white' : 'bg-paper'} data-id="element-227" data-mp="y7tqpsgwvmfm" data-mpi={index}>
                <td className="border-b border-brass/20 px-6 py-5 text-[16px] leading-[1.55] text-slate" data-id="element-228" data-mp="1uv85zmatxdc2">
                  {row.before}
                </td>
                <td className="border-b border-l border-brass/20 px-6 py-5 text-[16px] font-medium leading-[1.55] text-ink" data-id="element-229" data-mp="1m3y4n8tkgcwt">
                  {row.after}
                </td>
              </tr>)}
          </tbody>
        </table>

        {/* Mobile stacked cards */}
        <ul className="mt-10 space-y-4 md:hidden" data-id="element-230" data-mp="2embt4ht0imj8">
          {transformationRows.map(row => <li key={row.before} className="border border-brass/30 bg-white rounded-sharp" data-id="element-231" data-mp="29rxqbuc0td4j">
              <p className="border-b border-brass/20 bg-paper px-5 py-4 text-[15px] leading-[1.5] text-slate" data-id="element-232" data-mp="2xpnf6n9jddqc">
                {row.before}
              </p>
              <p className="px-5 py-4 text-[15px] font-medium leading-[1.5] text-ink" data-id="element-233" data-mp="2jvmj619yy4to">
                {row.after}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}